import { render, staticRenderFns } from "./Examine.vue?vue&type=template&id=008e06bf&scoped=true&"
import script from "./Examine.vue?vue&type=script&lang=js&"
export * from "./Examine.vue?vue&type=script&lang=js&"
import style0 from "./Examine.vue?vue&type=style&index=0&id=008e06bf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e06bf",
  null
  
)

export default component.exports